import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import signupImage from "../images/signup.png";
import axios from "axios";
import { API_URL } from "../components/Constant";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import OTPInput from "../components/Otp";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import Colors from "../components/Colors";
import TextfieldComponent from "../components/TextfeildComponent";

function CreatorSignUp() {
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryCode, setCountryCode] = useState("+91");
  const [nameError, setNameError] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [countryCodeError, setCountryCodeError] = useState("");
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [signupError, setSignupError] = useState("");
  const [isOtp, setIsOtp] = useState(false);
  const [isOtpSuccess, setIsOtpSuccess] = useState(false);

  // Handle change for name field
  const handleNameChange = (e) => {
    setName(e.target.value);
    setNameError("");
    setSignupError("");
  };

  const handleCountryCodeChange = (e) => {
    let newValue = e.target.value;
    if (/^\+?\d*$/.test(newValue)) {
      if (newValue.length <= 4) {
        setCountryCode(newValue);
      }
    }
    setCountryCodeError("");
    setPhoneNumberError("");
    setSignupError("");
  };

  const handlePhoneChange = (e) => {
    const newValue = e.target.value;
    if (/^\d*$/.test(newValue) && newValue.length <= 10) {
      setPhoneNumber(newValue);
    }
    setPhoneNumberError("");
    setCountryCodeError("");
    setSignupError("");
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
    setPasswordError("");
    setSignupError("");
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // Handle form submission (Register button click)
  const handleRegister = async () => {
    const country = countryCode.replace(/^\+/, "");

    if (name.trim() === "") {
      setNameError("Please enter your name");
    } else if (name.length > 60) {
      setNameError("Name is too long.");
    } else if (country.trim() === "") {
      setCountryCodeError("Please enter your country code");
    } else if (phoneNumber.trim() === "") {
      setPhoneNumberError("Please enter your phone number");
    } else if (password.trim() === "") {
      setPasswordError("Please create a password");
    } else if (password.length > 64) {
      setPasswordError("Password is too long.");
    } else if (password.length < 4) {
      setPasswordError("Password is too short.");
    } else {
      try {
        // First API call to check if the phone number exists
        const response = await axios.post(
          `${API_URL}/check_phone_number_exist`,
          {
            countryCode: countryCode,
            phone: phoneNumber,
          },
        );
        console.log(response.data);

        if (response.data.success === true) {
          try {
            // Second API call to create OTP if phone number exists
            const otpResponse = await axios.post(`${API_URL}/otp_creation`, {
              countryCode: countryCode,
              phone: phoneNumber,
            });

            console.log(otpResponse.data);

            if (otpResponse.data.success === true) {
              setIsOtp(true);
            } else {
              // Show OTP creation error
              console.log("Entered OTP creation error block");
              console.log(otpResponse.data.message);
              setSignupError(
                otpResponse.data.message ||
                  "Failed to create OTP. Please try again.",
              );
            }
          } catch (error) {
            // Handle errors from the OTP creation API call
            console.error("OTP creation request failed:", error);

            if (error.response && error.response.data) {
              // API returned a response with an error message
              setSignupError(
                error.response.data.message || "OTP creation failed.",
              );
            } else {
              // Network or other unknown error
              setSignupError(
                "An error occurred while creating the OTP. Please try again.",
              );
            }
          }
        } else {
          // Handle errors from the phone number check
          setSignupError(response.data.error || "Phone number does not exist.");
        }
      } catch (error) {
        // Handle errors from the phone number check API call
        console.error("Phone number check request failed:", error);

        if (error.response && error.response.data) {
          // API returned a response with an error message
          setSignupError(
            error.response.data.message || "Phone number check failed.",
          );
        } else {
          // Network or other unknown error
          setSignupError(
            "An error occurred while checking the phone number. Please try again.",
          );
        }
      }
    }
  };

  const handleSignInButtonClick = () => {
    window.location.href = "/creator-signin";
  };

  useEffect(() => {
    console.log(isOtpSuccess);

    if (isOtpSuccess) {
      const insertPlayerData = async () => {
        const country = countryCode.replace(/^\+/, "");

        try {
          const response = await axios.post(
            `${API_URL}/insert_creator_details`,
            {
              name: name,
              countryCode: country,
              phone: phoneNumber,
              password: password,
            },
          );
          //console.log(response.data)
          if (response.data.success === true) {
            // console.log(response.data.tocken)
            localStorage.setItem("CreatorId", response.data.creator_id);
            localStorage.setItem("CreatorTocken", response.data.tocken);
            window.location.href = "/creator-landing";
          }
        } catch (error) {
          console.error("something went wrong", error);
        }
      };

      // Call the function
      insertPlayerData();
    }
  }, [isOtpSuccess]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        background: Colors.Tidesbg,
        width: "100%",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          background: Colors.signupboxbg,
          width: "100%",
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
          maxWidth: { md: "40%", xs: "90%" },
          maxHeight: { md: "82%", xs: "60%" },
          borderRadius: "28px",
          borderColor: "#ee8e4c !important",
          border: "2px solid",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            height: "100%",
            gap: "32px",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: { md: "95%", xs: "90%" },
            maxHeight: "90%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: { md: "80%", xs: "100%" },
              height: "100%",
              justifyContent: "center",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                height: "fit-content",
                justifyContent: "center",
                alignItems: "center",
                gap: "20px",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Roboto",
                  fontSize: "28px",
                  fontWeight: 600,
                  color: "#fff",
                }}
              >
                Welcome!
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  height: "fit-content",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  gap: "4px",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Roboto",
                    fontSize: { xs: "12px", md: "14px" },
                    fontWeight: 400,
                    color: "#fff",
                  }}
                >
                  Nick name:
                </Typography>
                <TextfieldComponent value={name} onChange={handleNameChange} />
                {nameError && (
                  <Typography
                    sx={{
                      color: "red",
                      fontFamily: "Roboto",
                      fontSize: { xs: "12px", md: "14px" },
                      fontWeight: 400,
                    }}
                  >
                    {nameError}
                  </Typography>
                )}
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  height: "fit-content",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  gap: "8px",
                }}
              >
                <Box sx={{ width: { md: "20%", xs: "35%" } }}>
                  <Typography
                    sx={{
                      fontFamily: "Roboto",
                      fontSize: { xs: "12px", md: "14px" },
                      fontWeight: 400,
                      color: "#fff",
                    }}
                  >
                    Country code:
                  </Typography>
                  <TextfieldComponent
                    value={countryCode}
                    onChange={handleCountryCodeChange}
                  />
                </Box>
                <Box sx={{ width: { md: "80%", xs: "65%" } }}>
                  <Typography
                    sx={{
                      fontFamily: "Roboto",
                      fontSize: { xs: "12px", md: "14px" },
                      fontWeight: 400,
                      color: "#fff",
                    }}
                  >
                    Phone number:
                  </Typography>
                  <TextfieldComponent
                    value={phoneNumber}
                    onChange={handlePhoneChange}
                  />
                </Box>
              </Box>
              {countryCodeError && (
                <Typography
                  sx={{
                    color: "red",
                    fontFamily: "Roboto",
                    fontSize: { xs: "12px", md: "14px" },
                    fontWeight: 400,
                  }}
                >
                  {countryCodeError}
                </Typography>
              )}
              {phoneNumberError && (
                <Typography
                  sx={{
                    color: "red",
                    fontFamily: "Roboto",
                    fontSize: { xs: "12px", md: "14px" },
                    fontWeight: 400,
                  }}
                >
                  {phoneNumberError}
                </Typography>
              )}

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  height: "fit-content",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  gap: "4px",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Roboto",
                    fontSize: { xs: "12px", md: "14px" },
                    fontWeight: 400,
                    color: "#fff",
                  }}
                >
                  Password:
                </Typography>
                <TextfieldComponent
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={handlePasswordChange}
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={togglePasswordVisibility}
                          edge="end"
                          aria-label="toggle password visibility"
                          color="primary"
                        >
                          {showPassword ? (
                            <VisibilityOutlinedIcon
                              sx={{
                                color: Colors.signupBorder,
                                fontSize: { md: "18px", xs: "12px" },
                                marginRight: "10px",
                              }}
                            />
                          ) : (
                            <VisibilityOffOutlinedIcon
                              sx={{
                                color: Colors.signupBorder,
                                fontSize: { md: "18px", xs: "12px" },
                                marginRight: "10px",
                              }}
                            />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                    sx: {
                      height: { md: "41px", xs: "34px" },
                      padding: "4px 10px 4px 0px",
                      fontSize: { md: "14px", xs: "12px" },
                    },
                  }}
                  sx={{
                    borderRadius: "8px",
                  }}
                />

                {passwordError && (
                  <Typography
                    sx={{
                      color: "red",
                      fontFamily: "Roboto",
                      fontSize: { xs: "12px", md: "14px" },
                      fontWeight: 400,
                    }}
                  >
                    {passwordError}
                  </Typography>
                )}
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  height: "100%",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  gap: "8px",
                  marginTop: { md: "24px", xs: "16px" },
                }}
              >
                <Button
                  onClick={handleRegister}
                  sx={{
                    background: Colors.button2,
                    color: Colors.button2font,
                    height: { md: "36px", xs: "32px" },
                    width: "100%",
                    border: "1px solid",
                    borderColor: Colors.button2Border,
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontSize: "12px",
                    transition: "background 0.3s, transform 0.3s",
                    "&:hover": {
                      background: Colors.button2,
                      transform: "scaleY(1.05)",
                    },
                    "&:active": {
                      background: Colors.button2,
                    },
                  }}
                >
                  Register
                </Button>
                {signupError && (
                  <Typography
                    sx={{
                      color: "red",
                      fontFamily: "Roboto",
                      fontSize: { xs: "12px", md: "14px" },
                      fontWeight: 400,
                    }}
                  >
                    {signupError}
                  </Typography>
                )}
              </Box>

              <Typography
                sx={{ fontSize: { xs: "12px", md: "16px" }, color: "#fff" }}
              >
                Already have an account?
                <Typography
                  component="span"
                  sx={{
                    color: Colors.signupBorder,
                    display: "inline",
                    marginLeft: { xs: "4px", md: "8px" },
                    fontSize: { xs: "14px", md: "20px" },
                    cursor: "pointer",
                  }}
                  onClick={handleSignInButtonClick}
                >
                  Sign in
                </Typography>
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      {isOtp && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: "1000",
          }}
        >
          <Box
            sx={{
              width: { md: "25%", sm: "35%", xs: "75%" },
              backgroundColor: "#ffffff",
              borderRadius: "8px",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "36px",
            }}
          >
            {/* Close Button */}
            <Box
              sx={{
                display: "flex",
                width: "100%",
                justifyContent: "flex-end",
              }}
            >
              <IconButton
                onClick={() => {
                  setIsOtp(false); // Reset the game state
                  window.location.reload(); // Refresh the page
                }}
                sx={{
                  color: "#6b6b6b",
                  "&:hover": {
                    color: "#000000",
                  },
                }}
              >
                <CloseOutlinedIcon />
              </IconButton>
            </Box>

            <OTPInput
              phoneNumber={phoneNumber}
              countryCode={countryCode}
              setIsOtpSuccess={setIsOtpSuccess}
            ></OTPInput>
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default CreatorSignUp;
